import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import underlineimage2 from "../assets/images/title-shape-2.png";
import numbersbackground from "../assets/images/Esportsec/esportsnumber.png";
import friendinvite from "../assets/images/home.png";
import icon1 from "../assets/images/constantly-icon-01.png";
import icon2 from "../assets/images/constantly-icon-02.png";
import icon3 from "../assets/images/constantly-icon-03.png";
import icon4 from "../assets/images/constantly-icon-04.png";

interface StatItem {
  number: string;
  labelKey: string;
  icon: string;
}

const Numbers: React.FC = () => {
  const { t } = useTranslation();

  const stats: StatItem[] = [
    { number: "16M+", labelKey: "stats.activeGamers", icon: icon1 },
    { number: "200k+", labelKey: "stats.tournaments", icon: icon2 },
    { number: "40+", labelKey: "stats.clients", icon: icon3 },
    { number: "100M+", labelKey: "stats.winnings", icon: icon4 },
  ];

  return (
    <div className="relative bg-white">
      {/* TOP TITLE SECTION */}
      <div className="text-center py-10 px-4">
        <h2 className="text-[48px] font-oswald font-extrabold text-[#070B28]">
          {t("numbers.title")}
        </h2>
        <img
          src={underlineimage}
          alt="underline"
          className="mx-auto mt-2 mb-4 w-[120px] h-auto"
        />
        <p className="text-[16px] md:text-[18px] font-medium font-proxima max-w-xl mx-auto mb-12 text-[#070B28]">
          {t("numbers.subtitle")}
        </p>
      </div>

      {/* OVERLAPPING STATS */}
      <div className="relative z-20">
        <div className="flex justify-center gap-6 flex-wrap -mb-20 px-4">
          {stats.map((item, index) => (
            <div
              key={index}
              className="bg-[#070B28] text-white w-[250px] h-[250px] rounded-full flex flex-col pt-[70px] items-center shadow-xl border-[10px] border-white relative"
            >
              <div className="absolute top-[-25px]">
                <div className="absolute top-1/2 left-1/2 w-[80px] h-[80px] bg-[rgba(255,40,40,0.2)] rounded-full -translate-x-1/2 -translate-y-1/2 z-0"></div>
                <div className="w-[70px] h-[70px] rounded-full bg-[#f32424] flex justify-center items-center relative z-10 shadow-lg">
                  <img src={item.icon} alt={`icon-${index}`} className="w-9 h-9" />
                </div>
              </div>
              <h3 className="text-5xl font-bold mb-3">{item.number}</h3>
              <p className="text-[18px] mt-1 font-proxima text-center px-2 max-w-[130px]">
                {t(item.labelKey)}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* BACKGROUND WITH CHARACTERS */}
      <div>
        <div
          className="text-center px-4 overflow-hidden"
          style={{
            backgroundImage: `url(${numbersbackground})`,
            backgroundColor: "#070B28",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "820px",
          }}
        >
          <div className="pt-16">
            <h2 className="text-[48px] font-oswald font-extrabold text-white mt-[90px]">
              {t("numbers.whyDownload")}
            </h2>
            <img
              src={underlineimage2}
              alt="underline"
              className="mx-auto mt-2 mb-4 w-[120px] h-auto"
            />
            <p className="text-[16px] md:text-[18px] font-medium font-proxima max-w-xl mx-auto mb-12 text-[#ffffff]">
              {t("numbers.whyText")}
            </p>

            <div className="relative z-10 flex flex-col md:flex-row items-center justify-center gap-12 px-6 max-w-[1140px] mx-auto">
              <div className="text-[#ffffff] md:w-1/2 text-left">
                <h3 className="text-[24px] md:text-[28px] font-proxima font-bold mb-[8px]">
                  {t("numbers.getAppNow")}
                </h3>
                <h4 className="text-[20px] font-proxima font-medium leading-[1.2] mb-[25px]">
                  {t("numbers.downloadEase")}
                </h4>
                <ul className="list-disc list-inside text-[15px] leading-6 pl-5 mb-6 font-proxima">
                  <li>{t("numbers.feature1")}</li>
                  <li>{t("numbers.feature2")}</li>
                  <li>{t("numbers.feature3")}</li>
                  <li>{t("numbers.feature4")}</li>
                </ul>

             
              </div>

              <div className="md:w-1/2 flex justify-center">
                <img
                  src={friendinvite}
                  alt={t("numbers.imageAlt")}
                  className="w-full max-w-[340px] md:max-w-[430px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Numbers;
